export default __webpack_public_path__ + "static/media/fix-d.f8aecbb5.png";